// As telas de plano são do módulo assinaturas (/assinaturas/planos/*), outro bundle. Aqui ficam
// só como redirecionamento com página inteira, para /planos/* e para os /<modulo>/planos/* que os
// routers dos módulos montam com este arquivo. As rotas públicas abaixo seguem no core.
const redirecionaParaAssinaturas = (to) => {
    window.location.href = '/assinaturas' + to.fullPath.substring(to.fullPath.indexOf('/planos/'))
}

const routes = [
    {
        path: '/',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'meuPlano',
                path: '/planos/meu_plano',
                beforeEnter: redirecionaParaAssinaturas
            },
            {
                path: '/planos',
                redirect: '/planos/meu_plano'
            },
            {
                name: 'alterarDadosPlano',
                path: '/planos/alterar_dados',
                beforeEnter: redirecionaParaAssinaturas
            },
            {
                name: 'contratarDadosPlano',
                path: '/planos/contratar',
                beforeEnter: redirecionaParaAssinaturas
            },
            {
                name: 'resumoPlano',
                path: '/planos/resumo/:hash',
                beforeEnter: redirecionaParaAssinaturas
            }
        ]
    },
    {
        name: 'assinaturaBoleto',
        path: '/assinatura/boleto',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'assinaturaBoletoContaIntegrada',
        path: '/assinatura/boleto_ci',
        component: () => import('../views/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'assinaturaBoletoId',
        path: '/b/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        path: '/gerar_boleto_pagamento',
        component: () => import('../components/SegundaVia/index'),
        meta: { public: true }
    }
]

export default routes
